import { Link } from "react-router-dom";
import { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../utils/firebase";
import YouTubeIcon from "../../assets/techStackIcons/youTubeIcon";
import LinkedInIcon from "../../assets/techStackIcons/linkedInIcon";
import GitHubIcon from "../../assets/techStackIcons/gitHubIcon";
import FeedbackMessage from "../../components/FeedbackMessage";
import "./styles.css";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [confirmationMessage, setConfirmationMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorMessage("");
    setConfirmationMessage("");

    try {
      const docRef = await addDoc(collection(db, "mail"), {
        to: ["kenneth.blanton22@gmail.com"],
        message: {
          subject: `${formData.name} from ${formData.email} sent you a message!`,
          html: formData.message,
        },
      });
      console.log("Document written with ID: ", docRef.id);
      setConfirmationMessage("Your message has been sent successfully!");
    } catch (e) {
      console.error("Error adding document: ", e);
      setErrorMessage(
        "There was an error submitting your message. Please try again later."
      );
    } finally {
      setLoading(false);
    }

    // Reset form after submission
    setFormData({ name: "", email: "", message: "" });
  };

  return (
    <>
      <h1>CONTACT ME</h1>

      <div className="contact-container">
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="name">NAME</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">EMAIL</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">MESSAGE</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>
          <button type="submit" className="submit-button">
            send
          </button>
        </form>
        {loading && (
          <FeedbackMessage message="Sending your message..." type="loading" />
        )}
        {confirmationMessage && (
          <FeedbackMessage message={confirmationMessage} type="success" />
        )}
        {errorMessage && (
          <FeedbackMessage message={errorMessage} type="error" />
        )}
        <h2>OTHER LINKS</h2>
        <div className="homeLinks">
          <Link
            to={"https://www.youtube.com/@KennethBCoding"}
            target="_blank"
            rel="noopener noreferrer"
            className="regularLinks"
            style={{
              border: "1px solid #0000",
              boxShadow: "1px 1px 2px #ff0000, 0px 0px 4px #000",
            }}
            onMouseEnter={(e) => {
              e.target.style.boxShadow =
                "1px 1px 2px #ff0000, 0px 0px 4px #000";
              e.target.style.background = "#ff0000";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#fff";
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.boxShadow =
                "1px 1px 2px #ff0000, 0px 0px 4px #000";
              e.target.style.background = "none";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#ff0000";
              }
            }}
          >
            {YouTubeIcon()}
          </Link>
          <Link
            to={"https://www.linkedin.com/in/kenneth-blanton/"}
            target="_blank"
            rel="noopener noreferrer"
            className="regularLinks"
            style={{
              border: "1px solid #0000",
              boxShadow: "1px 1px 2px #0077b5, 0px 0px 4px #000",
            }}
            onMouseEnter={(e) => {
              e.target.style.boxShadow =
                "1px 1px 2px #0077b5, 0px 0px 4px #000";
              e.target.style.background = "#0077b5";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#fff";
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.boxShadow =
                "1px 1px 2px #0077b5, 0px 0px 4px #000";
              e.target.style.background = "none";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#0077b5";
              }
            }}
          >
            {LinkedInIcon()}
          </Link>
          <Link
            to={"https://github.com/kenneth-blanton"}
            target="_blank"
            rel="noopener noreferrer"
            className="regularLinks"
            style={{
              border: "1px solid #0000",
              boxShadow: "1px 1px 2px #000, 0px 0px 4px #000",
            }}
            onMouseEnter={(e) => {
              e.target.style.boxShadow = "1px 1px 2px #000, 0px 0px 4px #000";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#fff";
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.boxShadow = "1px 1px 2px #000, 0px 0px 4px #000";
              const svgElement = e.target.querySelector("svg");
              if (svgElement) {
                svgElement.style.fill = "#000";
              }
            }}
          >
            {GitHubIcon()}
          </Link>
        </div>
      </div>
      <div className="homeLinks">
        <Link to={"/"} className="regularLinks">
          home
        </Link>
      </div>
    </>
  );
}

export default Contact;
